import styled from "styled-components";
import { default as _ReactCalendar } from "react-calendar";
import { ReactCalendarProps } from "./Calendar.types";

export const ReactCalendar = styled(_ReactCalendar)<ReactCalendarProps>`
  background: ${(p) => p.theme.palette.layout.depth3};
  color: ${(p) => p.theme.palette.layout.depth6};
  font-size: ${(p) => p.theme.fontSize.md};
  line-height: ${(p) => p.theme.lineHeight.sm};
  padding: ${(p) => p.theme.spacing.md};
  border-radius: ${(p) => p.theme.radius.radius2};
  border: none;

  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  button {
    margin: 0;
    border: 0;
    outline: none;
  }
  button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    display: flex;
    height: 44px;
    margin-bottom: ${(p) => p.theme.spacing.sm};
  }
  .react-calendar__navigation__label {
    text-transform: capitalize;
  }
  .react-calendar__navigation button {
    background: none;
    color: ${(p) => p.theme.palette.layout.depth6};
  }
  .react-calendar__navigation button svg {
    height: 1rem;
    width: 1rem;
  }

  .react-calendar__navigation button:disabled {
    background-color: ${(p) => p.theme.palette.primary.opacity3};
  }
  .react-calendar__navigation button:enabled:hover {
    background-color: ${(p) => p.theme.palette.primary.opacity2};
    border-radius: ${(p) => p.theme.radius.radius2};
  }
  .react-calendar__month-view__weekdays {
    padding-bottom: ${(p) => p.theme.spacing.lg};
    display: flex;
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.75em;
  }
  .react-calendar__month-view__weekdays__weekday {
    color: ${(p) => p.theme.palette.layout.depth5};
    * {
      text-decoration: none;
    }
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    font-weight: bold;
  }

  .react-calendar__month-view__days__day {
    color: white;
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: ${(p) => p.theme.spacing.sm};
    color: ${(p) => p.theme.palette.layout.depth6};
  }
  .react-calendar__tile {
    // calendar day tile
    max-width: 100%;
    padding: ${(p) => p.theme.spacing.sm};
    background: none;
    text-align: center;
    line-height: ${(p) => p.theme.lineHeight.xs2};
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    // hover on general tile
    background-color: ${(p) => p.theme.palette.primary.opacity2};
    border-radius: ${(p) => p.theme.radius.radius2};
  }
  .react-calendar__tile--now {
    // today (if not active)
    border-radius: ${(p) => p.theme.radius.radius2};
    border: solid 1px ${(p) => p.theme.palette.primary.main};
  }

  .react-calendar__tile--active,
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    // active target
    color: ${(p) => p.theme.palette.primary.contrastText};
    border-radius: ${(p) => p.theme.radius.radius2};
    background-color: ${(p) => p.theme.palette.primary.main};
  }
`;
